/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Differences_Actions_HeadingInputs */



/**
* | output |
* | --- |
* | "Differences & Actions" |
*
* @param {Compare_Event_Groups_Differences_Actions_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_differences_actions_heading = /** @type {((inputs?: Compare_Event_Groups_Differences_Actions_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Differences_Actions_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Différences et actions")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterschiede und Maßnahmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Differenze e azioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Различия и действия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Diferencias y acciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("差异与行动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("違いと行動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतर और कार्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diferenças e ações")
	return /** @type {LocalizedString} */ ("Differences & Actions")
});